query getKioskSurveys($companyId: Int!, $id: String!) {
  kioskSurveys(companyId: $companyId, id: $id) {
    name
    surveyCode
    previewCode
    companyId
    languageId
    langISOCode
  }
}
